var OwlExtra = function(){

    var _single = function(event){
        
    }

    return {

        singleSlide: function(e,c){
            _single(e,c);
        }
    }

}();